import React from "react";
import { useDarkMode } from "context/DarkModeProvider";
import CommonHeader from "./CommonHeader";

const ClassLayout = ({ children }) => {
    const { darkMode } = useDarkMode();
    return (
        <div style={{ background: darkMode ? "#0f172a" : "var(--lightModeBack)", }}>
            <main className="flex-1 p-4" style={{}}>
                {children}
            </main>
        </div >
    );
}

export default ClassLayout;